/**
 * New images from /public/new/ - use across the app for consistency.
 * Hero uses 1, 2, 3; pitches use 1, 2. Others available for gallery, sections, etc.
 */
export const NEW_IMAGES = {
  hero: ["/new/1.jpg", "/new/2.jpg", "/new/3.jpg"] as const,
  /** Additional images for gallery, sections, page heroes */
  gallery: [
    "/gallary/1.jpeg",
    "/gallary/2.jpeg",
    "/gallary/6.jpeg",
    "/gallary/9.jpeg",
    "/gallary/10.jpeg",
    "/gallary/11.jpeg",
    "/gallary/12.jpeg",
    "/new/DSC_3234-2.jpg",
    "/gallary/13.jpeg",
    "/gallary/14.jpeg",
    "/gallary/15.jpeg",
  ] as const,
  /** Full-width parallax / hero banners */
  parallax: "/new/DSC08873.JPG",
  /** Single feature images */
  feature: "/new/DSC_2833-2.jpg",
  /** Scheduling CTA background */
  scheduling: "/new/DSC06258.jpeg",
  /** About story section */
  aboutStory: "/new/DSC00623.JPG",
  /** About enabler collage (5 images) */
  aboutEnabler: [
    "/new/DSC_2833-2.jpg",
    "/new/DSC_2928-2.jpg",
    "/new/DSC_3234-2.jpg",
    "/new/DSC06258.jpeg",
    "/new/DSC08873.JPG",
  ] as const,
  /** Contact/About page heroes */
  pageHero: "/new/DSC08873.JPG",
  pageHeroAlt: "/new/DSC06258.jpeg",
  /** Gallery preview (4 images) */
  galleryPreview: [
    "/new/DSC_2833-2.jpg",
    "/new/DSC_2928-2.jpg",
    "/new/DSC_3234-2.jpg",
    "/new/DSC06258.jpeg",
  ] as const,
  /** Synthetic turf (Futsal 3) - images from public/synthetic/ */
  synthetic: ["/synthetic/1.jpeg", "/synthetic/2.JPG"] as const,
  /** Other sports - add your images to public/sports/ or update these paths */
  otherSports: {
    basketball: "/sports/basket-ball.jpeg",
    newcom: "/gallary/4.jpeg",
    volleyball: "/gallary/5.jpeg",
    training: "/gallary/6.jpeg",
    camps: "/gallary/7.jpeg",
  } as const,
} as const;
